module.exports = __webpack_public_path__ + "static/edewor-731f3dabae4b102c92f69b19d99b30b7.png";